module.exports = __webpack_public_path__ + "img/31.9ce1654c.jpg";